var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKlarna = function SvgKlarna(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-8 0 24 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.018.66H5.812a5.633 5.633 0 0 1-2.28 4.55l-.873.653 3.38 4.613h2.784L5.71 6.231A7.803 7.803 0 0 0 8.018.661ZM.132 10.476h2.259V.66H.132z"
  }))));
};
export default SvgKlarna;